import React, { useState, useCallback, useEffect, useContext } from "react";
import useReactRouter from "use-react-router";
import { Paper, Grid, Typography, Button } from "@material-ui/core";
import { getUserOne } from "../../../API/User";
import { makeStyles } from "@material-ui/styles";
import { LangContext } from "../../../Context/Langcontext";
import DefineData from "../../../Views/app/limit/defineData";
import DefineMap from "../../../Views/app/limit/defineMap";
import { getServiceUser } from "../../../API/Service";
import { getFiberObtic } from "../../../API/Fiber";
import DefinePremium from "../../../Views/app/limit/definePremium";

const useStyle = makeStyles((theme) => ({
  rowDetail: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    margin: "1rem 8rem",
    whiteSpace: "nowrap",
  },
  griditem: {},
  paper: {
    boxShadow: "unset",
    backgroundColor: "#f4f4f4",
    borderRadius: 8,
  },
  fontprimary: {
    fontSize: "1rem",
    fontWeight: 700,
    color: "#595a5a",
  },
  fontsecondary: {
    fontSize: "1rem",
    fontWeight: 200,
    color: "#595a5a",
  },
  gridbtn: {
    margin: "2rem 0rem",
  },
  activebtn: {
    padding: "0.5rem 4rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#595a5a",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#595a5a",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  nonactive: {
    padding: "0.5rem 4rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#9b9b9b",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#9b9b9bd9",
    },
  },
}));

const Servicesetting = () => {
  const classes = useStyle();
  const { match, history } = useReactRouter();
  const [fetch, setfetch] = useState(false);
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const [state, setstate] = useState({
    name: "",
    organization: "",
    register: "",
    period: "",
    role: "",
    data: [],
    map: [],
    premium: [],
    fiber: [],
  });

  const convertDate = useCallback(
    (d) => {
      const monthNames = [
        lang.January,
        lang.February,
        lang.March,
        lang.April,
        lang.May,
        lang.June,
        lang.July,
        lang.August,
        lang.September,
        lang.October,
        lang.November,
        lang.December,
      ];

      let dateObj = new Date(d);
      let month = monthNames[dateObj.getMonth()];
      let day = String(dateObj.getDate()).padStart(2, "0");
      let year = dateObj.getFullYear();

      let output = `${day} ${month} ${
        langContext.lang.locale === "th" ? Number(year + 543) : year
      }`;
      return output;
    },
    [langContext, lang]
  );

  const getData = useCallback(async () => {
    const get = await getUserOne(match.params.id);
    const servicedata = await getServiceUser(match.params.id);
    // console.log(servicedata)
    const getfiber = await getFiberObtic();
    if (get.status.code === 200 && get.data.length !== 0) {
      const dataservice = servicedata.data
        .filter((rs) => {
          return (
            rs.category === "data" &&
            (rs.user_roles.find((r) => r === get.data[0].role) ||
              rs.user_specials.find((r) => r === match.params.id))
          );
        })
        .sort((a, b) => {
          return a.default === b.default ? 0 : a.default ? -1 : 1;
        });
      const mapservice = servicedata.data
        .filter((rs) => {
          return (
            rs.category === "map" &&
            (rs.user_roles.find((r) => r === get.data[0].role) ||
              rs.user_specials.find((r) => r === match.params.id))
          );
        })
        .sort((a, b) => {
          return a.default === b.default ? 0 : a.default ? -1 : 1;
        });

      const premiummapservice = servicedata.data
        .filter((rs) => {
          return (
            rs.category === "premium" &&
            (rs.user_roles.find((r) => r === get.data[0].role) ||
              rs.user_specials.find((r) => r === match.params.id))
          );
        })
        .sort((a, b) => {
          return a.default === b.default ? 0 : a.default ? -1 : 1;
        });

      setstate({
        ...state,
        name: `${get.data[0].first_name} ${get.data[0].last_name}`,
        organization: get.data[0].organization,
        register: get.data[0].created_at,
        period: get.data[0]
          ? get.data[0].contract !== undefined
            ? `${convertDate(get.data[0].contract.start_date)} - ${convertDate(
                get.data[0].contract.end_date
              )}`
            : "-"
          : "-",
        role: get.data[0].role,
        data: dataservice,
        map: mapservice,
        premium: premiummapservice,
        fiber: getfiber.data,
      });
    }
  }, [match, state, convertDate]);

  useEffect(() => {
    if (!fetch) {
      getData();
      setfetch(true);
    } else {
    }
  }, [fetch, getData]);

  return (
    <div style={{ margin: "2rem" }}>
      <Paper className={classes.paper}>
        <Grid container>
          <Grid item lg={6} md={6} sm={12} xs={12} className={classes.griditem}>
            <div className={classes.rowDetail}>
              <Typography className={classes.fontprimary}>
                {langContext.lang.locale === "th"
                  ? `${lang.Name}${lang.Customer}`
                  : `${lang.Customer} ${lang.Name}`}
                :
              </Typography>
              <Typography
                className={classes.fontsecondary}
                style={{ marginLeft: "0.5rem" }}
              >
                {state.name}
              </Typography>
            </div>
          </Grid>
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <div className={classes.rowDetail}>
              <Typography className={classes.fontprimary}>
                {lang.Organization} :
              </Typography>
              <Typography
                className={classes.fontsecondary}
                style={{ marginLeft: "0.5rem" }}
              >
                {state.organization}
              </Typography>
            </div>
          </Grid>
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <div className={classes.rowDetail}>
              <Typography className={classes.fontprimary}>
                {lang.Register} :
              </Typography>
              <Typography
                className={classes.fontsecondary}
                style={{ marginLeft: "0.5rem" }}
              >
                {convertDate(state.register)}
              </Typography>
            </div>
          </Grid>
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <div className={classes.rowDetail}>
              <Typography className={classes.fontprimary}>
                {lang.Period} :
              </Typography>
              <Typography
                className={classes.fontsecondary}
                style={{ marginLeft: "0.5rem" }}
              >
                {state.period}
              </Typography>
            </div>
          </Grid>
        </Grid>
      </Paper>
      <Grid container className={classes.gridbtn}>
        <Grid item xs={12}>
          <Button
            variant="contained"
            className={
              match.params.service === "data"
                ? classes.activebtn
                : classes.nonactive
            }
            onClick={() => {
              history.push(`/app/limit/setting/${match.params.id}/data`);
            }}
          >
            Data API
          </Button>
          <Button
            variant="contained"
            className={
              match.params.service === "map"
                ? classes.activebtn
                : classes.nonactive
            }
            style={{ marginLeft: "1rem" }}
            onClick={() => {
              history.push(`/app/limit/setting/${match.params.id}/map`);
            }}
          >
            Map API
          </Button>
          <Button
            variant="contained"
            className={
              match.params.service === "premium"
                ? classes.activebtn
                : classes.nonactive
            }
            style={{ marginLeft: "1rem" }}
            onClick={() => {
              history.push(`/app/limit/setting/${match.params.id}/premium`);
            }}
          >
            Premium API
          </Button>
        </Grid>
      </Grid>
      <Grid container>
        {match.params.service === "data" ? (
          <DefineData
            role={state.role}
            data={state.data}
            setfetch={setfetch}
            fetch={fetch}
            fiber={state.fiber}
          />
        ) : match.params.service === "map" ? (
          <DefineMap
            role={state.role}
            data={state.map}
            setfetch={setfetch}
            fetch={fetch}
            fiber={state.fiber}
          />
        ) : match.params.service === "premium" ? (
          <DefinePremium
            role={state.role}
            data={state.premium}
            setfetch={setfetch}
            fetch={fetch}
            fiber={state.fiber}
          />
        ) : null}
      </Grid>
    </div>
  );
};

export default Servicesetting;
